export function removeHtmlTags(str: string) {
  return str.replace(/<\/?[^>]+(>|$)/g, '')
}

export function replaceNbsp(str: string): string {
  return str.replace(/&nbsp;/g, ' ')
}

export function formatStringForSEO(str: string) {
  return removeHtmlTags(convertAnchorTags(convertListTags(replaceNbsp(str))))
}

/**
 * Converts anchor tags in a string to a format that includes the anchor href after the anchor text.
 * @param str - The input string containing anchor tags.
 * @returns A string with anchor tags converted to "anchorText href" format.
 *  * @example -"<a href="https://faq.beachbody.com/">visit BODi Support</a>", visit BODi Support https://faq.beachbody.com/
 */
export function convertAnchorTags(str: string): string {
  return str.replace(/<a[^>]*>(.*?)<\/a>/g, (match, anchorText) => {
    const hrefMatch = match.match(/href="([^"]*)"/)
    const href = hrefMatch ? hrefMatch[1] : ''
    return `${anchorText} ${href}`
  })
}

/**
 * Converts HTML `<li>` tags in a string to plain text by extracting the text content
 * of each list item and appending a space after it.
 *
 * @param str - The input string containing HTML `<li>` tags.
 * @returns A string with the text content of `<li>` tags, separated by spaces.
 *
 * @example - "<li>Item 1</li><li>Item 2</li>", "Item 1 Item 2 "
 */
export function convertListTags(str: string): string {
  return str.replace(/<li[^>]*>(.*?)<\/li>/g, (match, listText) => {
    return `${listText} `
  })
}
